export const selectAuthState = state => state.auth;
export const getUser = state => state.auth.user || {};
export const getGates = state => state.auth.gates || [];
export const getPortal = state => state.auth.portal;
export const getScopes = state => {
  const user = state.auth.user;
  return user ? user.scopes : [];
};
export const hasWriteUserScope = state => getScopes(state).includes('users-write');